import React, { PureComponent } from 'react';
import { Breadcrumb, BreadcrumbItem, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import moment from 'moment';

// components
import MortgageCalculatorForm from '../../forms/mortgage-calculator-form/mortgage-calculator-form';

// modules
import styles from '../Containers.module.scss';

class MortgageCalculator extends PureComponent {
  render() {
    return (
      <Container fluid className={styles.MortgageCalculator}>
        <Container>
          <Row>
            <Breadcrumb>
              <LinkContainer exact to="/">
                <BreadcrumbItem>
                  <Link to="/">Home</Link>
                </BreadcrumbItem>
              </LinkContainer>
              <LinkContainer exact to="/about">
                <BreadcrumbItem active>Mortgage Calculator</BreadcrumbItem>
              </LinkContainer>
            </Breadcrumb>
          </Row>
        </Container>
        <Container>
          <p>
            This calculator will compute the total monthly payment, total interest paid
            and total cost of the loan based on amounts input by the user. To use the
            calculator, simply input all of the appropriate values in the 'Inputs' section
            below. The results will be displayed in the "Results" section on the right.
          </p>
          <MortgageCalculatorForm
            initialValues={{
              amount: '',
              term: 30,
              interestRate: 4.01,
              startDate: moment().format('YYYY-MM-DD')
            }}
          />
          <p>
            The information provided by these calculators is intended for illustrative
            purposes only and is not intended to purport actual user-defined parameters.
            The default figures shown are hypothetical and may not be applicable to your
            individual situation. Be sure to consult a financial professional prior to
            relying on the results. This is for informational purposes only and NABOR is
            not a licensed lender.
          </p>
        </Container>
      </Container>
    );
  }
}

export default MortgageCalculator;



// WEBPACK FOOTER //
// ./src/containers/MortgageCalculator/MortgageCalculator.js